// import React, { useCallback, useState, useEffect } from "react";
// import { useDropzone } from "react-dropzone";
// import axios from "axios";
// import toast from "react-hot-toast";

// function RateLimitBanner({ retryAfter, onDismiss }) {
//   const [remaining, setRemaining] = useState(retryAfter || 0);

//   useEffect(() => {
//     if (!retryAfter) return;
//     setRemaining(retryAfter);
//     const interval = setInterval(() => {
//       setRemaining(s => {
//         if (s <= 1) { clearInterval(interval); onDismiss(); return 0; }
//         return s - 1;
//       });
//     }, 1000);
//     return () => clearInterval(interval);
//   }, [retryAfter]);

//   const mins = Math.floor(remaining / 60);
//   const secs = remaining % 60;
//   const timeStr = mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;

//   return (
//     <div style={{
//       background: "rgba(243,139,168,.12)", border: "1px solid rgba(243,139,168,.4)",
//       borderRadius: 10, padding: "14px 18px", marginTop: 16,
//       display: "flex", alignItems: "center", gap: 12,
//     }}>
//       <span style={{ fontSize: 22 }}>⏳</span>
//       <div style={{ flex: 1 }}>
//         <div style={{ fontWeight: 700, color: "var(--err)", fontSize: 14, marginBottom: 2 }}>
//           API Rate Limit Reached
//         </div>
//         <div style={{ fontSize: 13, color: "var(--text2)" }}>
//           {remaining > 0
//             ? <>Please reconnect to the system in <strong style={{ color: "var(--err)" }}>{timeStr}</strong>.</>
//             : "You can retry now!"}
//         </div>
//       </div>
//       <button className="btn-ghost" style={{ fontSize: 11 }} onClick={onDismiss}>Dismiss</button>
//     </div>
//   );
// }

// export default function UploadZone({ onUploaded }) {
//   const [files, setFiles]         = useState([]);
//   const [loading, setLoading]     = useState(false);
//   const [progress, setProgress]   = useState({});
//   const [rateLimitInfo, setRateLimitInfo] = useState(null); 

//   const onDrop = useCallback((accepted) => {
//     const pdfs = accepted.filter(f => f.type === "application/pdf" || f.name.endsWith(".pdf"));
//     if (pdfs.length !== accepted.length) toast.error("Only PDF files are accepted.");
//     setFiles(prev => {
//       const names = new Set(prev.map(p => p.name));
//       return [...prev, ...pdfs.filter(f => !names.has(f.name))];
//     });
//   }, []);

//   const { getRootProps, getInputProps, isDragActive } = useDropzone({
//     onDrop,
//     accept: { "application/pdf": [".pdf"] },
//     multiple: true,
//   });

//   const removeFile = (name) => setFiles(prev => prev.filter(f => f.name !== name));
//   const clearAll   = () => setFiles([]);

//   const [fileProgress, setFileProgress] = useState({ done: 0, total: 0 }); // true per-file counter

//   const upload = async () => {
//     if (!files.length) { toast.error("No files selected"); return; }
//     setLoading(true);

//     const prog = {};
//     files.forEach(f => { prog[f.name] = "pending"; });
//     setProgress({ ...prog });
//     setFileProgress({ done: 0, total: files.length });

//     const allResults = [];
//     let hadRateLimit  = null;

//     try {
//       for (let i = 0; i < files.length; i++) {
//         const f = files[i];
//         const fd = new FormData();
//         fd.append("file", f);

//         try {
//           const res = await axios.post("/api/upload-one", fd, {
//             headers: { "Content-Type": "multipart/form-data" },
//           });

//           console.log(`📦 Response for "${f.name}":`, res.data);
//           console.log(JSON.stringify(res.data, null, 2));

//           const result = res.data?.results?.[0];
//           if (result) {
//             prog[result.file] = result.duplicate ? "duplicate" : (result.error ? "error" : "done");
//             allResults.push(result);
//             if (result.rate_limited) hadRateLimit = result;
//           } else {
//             prog[f.name] = "error";
//             allResults.push({ file: f.name, success: false, error: "No response", duplicate: false, rate_limited: false, retry_after: null, data: null });
//           }
//         } catch (err) {
//           console.error(`❌ Upload error for "${f.name}":`, err.response?.data || err.message);
//           prog[f.name] = "error";
//           allResults.push({
//             file: f.name,
//             success: false,
//             error: err.response?.data?.error || "Upload failed",
//             duplicate: false,
//             rate_limited: false,
//             retry_after: null,
//             data: null,
//           });
//         }

//         setProgress({ ...prog });
//         setFileProgress({ done: i + 1, total: files.length });
//       }

//       console.log("✅ All results:", allResults);
//       console.log(JSON.stringify(allResults, null, 2));

//       const ok   = allResults.filter(r => !r.error).length;
//       const dupe = allResults.filter(r =>  r.duplicate).length;
//       const bad  = allResults.filter(r =>  r.error && !r.rate_limited && !r.duplicate).length;

//       if (ok)   toast.success(`${ok} invoice${ok > 1 ? "s" : ""} extracted successfully!`);
//       if (dupe) {
//         const dupeNames = allResults.filter(r => r.duplicate).map(r => r.data?.invoice_no || r.file).join(", ");
//         toast.error(
//           dupe === 1
//             ? `This invoice (${dupeNames}) has already been extracted.`
//             : `${dupe} invoices were already extracted before: ${dupeNames}`,
//           { duration: 6000 }
//         );
//       }
//       if (bad)  toast.error(`${bad} file${bad > 1 ? "s" : ""} failed.`);

//       if (hadRateLimit) {
//         setRateLimitInfo({ retryAfter: hadRateLimit.retry_after || null });
//         toast.error("API rate limit hit — see banner below for retry time.");
//       }

//       onUploaded(allResults);
//       setFiles([]);
//       setProgress({});
//     } finally {
//       setLoading(false);
//       setFileProgress({ done: 0, total: 0 });
//     }
//   };

//   return (
//     <div className="upload-zone-wrap">
//       {loading && fileProgress.total > 0 && (
//         <div className="batch-loader-backdrop">
//           <div className="batch-loader-card">
//             <div className="spinner" />
//             <p className="batch-loader-title">Processing your invoices…</p>
//             <p className="batch-loader-sub">
//               {fileProgress.done} of {fileProgress.total} files processed
//             </p>
//             <div className="batch-loader-track">
//               <div
//                 className="batch-loader-fill"
//                 style={{ width: `${(fileProgress.done / fileProgress.total) * 100}%` }}
//               />
//             </div>
//           </div>
//         </div>
//       )}

//       {rateLimitInfo && (
//         <RateLimitBanner
//           retryAfter={rateLimitInfo.retryAfter}
//           onDismiss={() => setRateLimitInfo(null)}
//         />
//       )}
//       <div
//         {...getRootProps()}
//         className={`dropzone ${isDragActive ? "active" : ""}`}
//       >
//         <input {...getInputProps()} />
//         <div className="dz-icon">
//           <svg viewBox="0 0 64 64" fill="none" width="56" height="56">
//             <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="2" opacity=".15"/>
//             <path d="M32 20v16M24 28l8-8 8 8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
//             <path d="M20 42h24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity=".5"/>
//           </svg>
//         </div>
//         <p className="dz-title">
//           {isDragActive ? "Drop PDFs here…" : "Drag & drop PDF invoices"}
//         </p>
//         <p className="dz-sub">or click to browse · multiple files supported</p>
//       </div>

//       {files.length > 0 && (
//         <div className="file-list">
//           <div className="file-list-header">
//             <span>{files.length} file{files.length > 1 ? "s" : ""} queued</span>
//             <button className="btn-ghost" onClick={clearAll}>Clear all</button>
//           </div>
//           {files.map(f => (
//             <div key={f.name} className="file-row">
//               <span className="file-icon">📄</span>
//               <span className="file-name">{f.name}</span>
//               <span className="file-size">{(f.size / 1024).toFixed(0)} KB</span>
//               {progress[f.name] === "done"      && <span className="badge badge-ok">✓</span>}
//               {progress[f.name] === "duplicate" && <span className="badge badge-dupe" title="Already extracted">⚠ Duplicate</span>}
//               {progress[f.name] === "error"     && <span className="badge badge-err">✗</span>}
//               {progress[f.name] === "pending"   && <span className="badge badge-wait">…</span>}
//               {!progress[f.name] && (
//                 <button className="btn-remove" onClick={() => removeFile(f.name)}>×</button>
//               )}
//             </div>
//           ))}
//           <button
//             className="btn-primary btn-upload"
//             onClick={upload}
//             disabled={loading}
//           >
//             {loading
//               ? `Processing ${fileProgress.done}/${fileProgress.total} files…`
//               : `Extract ${files.length} Invoice${files.length > 1 ? "s" : ""}`}
//           </button>
//         </div>
//       )}
//     </div>
//   );
// }











import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import axios from "axios";
import toast from "react-hot-toast";
import { useAuth } from "../context/AuthContext";
import { ConfirmModal } from "./invoiceShared";

function RateLimitBanner({ retryAfter, onDismiss }) {
  const [remaining, setRemaining] = useState(retryAfter || 0);

  useEffect(() => {
    if (!retryAfter) return;
    setRemaining(retryAfter);
    const interval = setInterval(() => {
      setRemaining(s => {
        if (s <= 1) { clearInterval(interval); onDismiss(); return 0; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [retryAfter]);

  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;
  const timeStr = mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;

  return (
    <div style={{
      background: "rgba(243,139,168,.12)", border: "1px solid rgba(243,139,168,.4)",
      borderRadius: 10, padding: "14px 18px", marginTop: 16,
      display: "flex", alignItems: "center", gap: 12,
    }}>
      <span style={{ fontSize: 22 }}>⏳</span>
      <div style={{ flex: 1 }}>
        <div style={{ fontWeight: 700, color: "var(--err)", fontSize: 14, marginBottom: 2 }}>
          API Rate Limit Reached
        </div>
        <div style={{ fontSize: 13, color: "var(--text2)" }}>
          {remaining > 0
            ? <>Please reconnect to the system in <strong style={{ color: "var(--err)" }}>{timeStr}</strong>.</>
            : "You can retry now!"}
        </div>
      </div>
      <button className="btn-ghost" style={{ fontSize: 11 }} onClick={onDismiss}>Dismiss</button>
    </div>
  );
}

export default function UploadZone({ onUploaded }) {
  const [files, setFiles]         = useState([]);
  const [loading, setLoading]     = useState(false);
  const [progress, setProgress]   = useState({});
  const [rateLimitInfo, setRateLimitInfo] = useState(null); 
  const { user } = useAuth();
  const [vendorMismatch, setVendorMismatch] = useState(null); // { payload, resolve }

  const askVendorConfirm = (payload) =>
    new Promise((resolve) => setVendorMismatch({ payload, resolve }));

  // const resolveVendorMismatch = async (proceed) => {
  //   const { payload, resolve } = vendorMismatch;
  //   try {
  //     if (payload.invoice_id) {
  //       await axios.post(`/api/invoices/${payload.invoice_id}/vendor-resolve`, { proceed });
  //     }
  //   } catch (_) {}
  //   setVendorMismatch(null);
  //   resolve(proceed);
  // };


  // const resolveVendorMismatch = async (proceed) => {
  //   const { payload, resolve } = vendorMismatch;
  //   let resolveRes = null;
  //   try {
  //     if (payload.invoice_id) {
  //       const r = await axios.post(`/api/invoices/${payload.invoice_id}/vendor-resolve`, { proceed });
  //       resolveRes = r.data;
  //     }
  //   } catch (_) {}
  //   setVendorMismatch(null);
  //   if (proceed) {
  //     toast[resolveRes?.posted_to_erp ? "success" : "error"](
  //       resolveRes?.posted_to_erp ? "Vendor confirmed — sent to ERP." : "Vendor confirmed, but ERP push failed."
  //     );
  //   } else {
  //     toast.error("Vendor mismatch rejected — not sent to ERP.");
  //   }
  //   resolve(proceed);
  // };

  const onDrop = useCallback((accepted) => {
    const pdfs = accepted.filter(f => f.type === "application/pdf" || f.name.endsWith(".pdf"));
    if (pdfs.length !== accepted.length) toast.error("Only PDF files are accepted.");
    setFiles(prev => {
      const names = new Set(prev.map(p => p.name));
      return [...prev, ...pdfs.filter(f => !names.has(f.name))];
    });
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { "application/pdf": [".pdf"] },
    multiple: true,
  });

  const removeFile = (name) => setFiles(prev => prev.filter(f => f.name !== name));
  const clearAll   = () => setFiles([]);

  const [fileProgress, setFileProgress] = useState({ done: 0, total: 0 }); // true per-file counter

  const upload = async () => {
    if (!files.length) { toast.error("No files selected"); return; }
    setLoading(true);

    const prog = {};
    files.forEach(f => { prog[f.name] = "pending"; });
    setProgress({ ...prog });
    setFileProgress({ done: 0, total: files.length });

    const allResults = [];
    let hadRateLimit  = null;
    let transactionNo = null; 

    try {
      for (let i = 0; i < files.length; i++) {
        const f = files[i];
        const fd = new FormData();
        fd.append("file", f);
        fd.append("sub_index", String(i + 1));
        if (transactionNo) fd.append("transaction_no", transactionNo);

        // try {
        //   // const res = await axios.post("/api/upload-one", fd, {
        //   //   headers: { "Content-Type": "multipart/form-data" },
        //   // });

        //   const endpoint = user?.viaBypass ? "/api/erp-upload" : "/api/upload-one";
        //   const res = await axios.post(endpoint, fd, {
        //     headers: { "Content-Type": "multipart/form-data" },
        //   });

        //   if (user?.viaBypass) {
        //     if (res.data.match === true) {
        //       toast.success(`Vendor verified ✓ (${res.data.reported_vendor_name})`);
        //     } else if (res.data.match === false) {
        //       const proceed = await askVendorConfirm(res.data);
        //       if (!proceed) {
        //         prog[f.name] = "error";
        //         allResults.push({
        //           file: f.name, success: false,
        //           error: `Vendor mismatch: extracted "${res.data.extracted_vendor_name}" vs reported "${res.data.reported_vendor_name}" — cancelled by user`,
        //           duplicate: false, rate_limited: false, retry_after: null, data: null,
        //         });
        //         setProgress({ ...prog });
        //         setFileProgress({ done: i + 1, total: files.length });
        //         continue;
        //       }
        //     }
        //   }

        //   console.log(`📦 Response for "${f.name}":`, res.data);
        //   console.log(JSON.stringify(res.data, null, 2));

        //   if (!transactionNo && res.data?.transaction_no) {
        //     transactionNo = res.data.transaction_no; 
        //   }

        //   const result = res.data?.results?.[0];
        //   if (result) {
        //     prog[result.file] = result.duplicate ? "duplicate" : (result.error ? "error" : "done");
        //     allResults.push(result);
        //     if (result.rate_limited) hadRateLimit = result;
        //   } else {
        //     prog[f.name] = "error";
        //     allResults.push({ file: f.name, success: false, error: "No response", duplicate: false, rate_limited: false, retry_after: null, data: null });
        //   }
        // } catch (err) {
        //   console.error(`❌ Upload error for "${f.name}":`, err.response?.data || err.message);
        //   prog[f.name] = "error";
        //   allResults.push({
        //     file: f.name,
        //     success: false,
        //     error: err.response?.data?.error || "Upload failed",
        //     duplicate: false,
        //     rate_limited: false,
        //     retry_after: null,
        //     data: null,
        //   });
        // }


        try {
          const endpoint = user?.viaBypass ? "/api/erp-upload" : "/api/upload-one";
          const res = await axios.post(endpoint, fd, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          console.log(`📦 Response for "${f.name}":`, res.data);

          let result;

          if (user?.viaBypass) {
            const d = res.data;

            if (d.match === false) {
              // Ask the user to confirm or reject the vendor mismatch
              const proceed = await askVendorConfirm(d);

              if (proceed) {
                try {
                  // const r2 = await axios.post(`/api/invoices/${d.invoice_id}/vendor-resolve`, { proceed: true });
                  // const posted = !!r2.data.posted_to_erp;
                  // toast[posted ? "success" : "error"](
                  //   posted ? "Vendor confirmed, sent to ERP." : "Vendor confirmed, but ERP push failed."
                  // );
                  const r2 = await axios.post(`/api/invoices/${d.invoice_id}/vendor-resolve`, { proceed: true });
                  const posted   = !!r2.data.posted_to_erp;
                  const alreadyIn = !!r2.data.already_in_erp;
                  if (posted) {
                    toast.success("Vendor confirmed. Sent to ERP.");
                  } else if (alreadyIn) {
                    toast.warning("Vendor confirmed, but this invoice was already sent to ERP earlier.");
                  } else {
                    toast.error("Vendor confirmed, but ERP push failed.");
                  }
                  result = {
                    file: f.name,
                    success: posted,
                    error: posted ? null : "ERP push failed after vendor confirmation",
                    duplicate: false, rate_limited: false, retry_after: null,
                    data: r2.data.data || null,
                  };
                } catch (e) {
                  toast.error("Vendor confirmed, but the resolve call itself failed.");
                  result = { file: f.name, success: false, error: "vendor-resolve call failed", duplicate: false, rate_limited: false, retry_after: null, data: null };
                }
              } else {
                try {
                  await axios.post(`/api/invoices/${d.invoice_id}/vendor-resolve`, { proceed: false });
                } catch (_) {}
                toast.error("Vendor mismatch rejected, not sent to ERP.");
                result = {
                  file: f.name,
                  success: false,
                  error: `Vendor mismatch: extracted "${d.extracted_vendor_name}" vs reported "${d.reported_vendor_name}"`,
                  duplicate: false, rate_limited: false, retry_after: null, data: null,
                };
              }
            } else {
              // matched, or no vendor_name supplied, or extraction/duplicate outcome
              const inner = d.result || {};
              result = {
                file: inner.file || f.name,
                success: !!d.success,
                error: inner.error || (d.success ? null : (d.message || "Failed")),
                duplicate: !!inner.duplicate,
                rate_limited: !!inner.rate_limited,
                retry_after: inner.retry_after || null,
                data: inner.data || null,
              };
              if (d.match === true) toast.success(`Vendor verified ✓ (${d.reported_vendor_name})`);
            }
          } else {
            result = res.data?.results?.[0];
          }

          if (result) {
            prog[result.file] = result.duplicate ? "duplicate" : (result.error ? "error" : "done");
            allResults.push(result);
            if (result.rate_limited) hadRateLimit = result;
          } else {
            prog[f.name] = "error";
            allResults.push({ file: f.name, success: false, error: "No response", duplicate: false, rate_limited: false, retry_after: null, data: null });
          }
        } catch (err) {
          console.error(`❌ Upload error for "${f.name}":`, err.response?.data || err.message);
          prog[f.name] = "error";
          allResults.push({
            file: f.name,
            success: false,
            error: err.response?.data?.error || "Upload failed",
            duplicate: false,
            rate_limited: false,
            retry_after: null,
            data: null,
          });
        }

        setProgress({ ...prog });
        setFileProgress({ done: i + 1, total: files.length });
      }

      console.log("✅ All results:", allResults);
      console.log(JSON.stringify(allResults, null, 2));

      const ok   = allResults.filter(r => !r.error).length;
      const dupe = allResults.filter(r =>  r.duplicate).length;
      const bad  = allResults.filter(r =>  r.error && !r.rate_limited && !r.duplicate).length;

      if (ok)   toast.success(
        `${ok} invoice${ok > 1 ? "s" : ""} extracted successfully!${transactionNo ? ` (Txn: ${transactionNo})` : ""}`
      );
      if (dupe) {
        const dupeNames = allResults.filter(r => r.duplicate).map(r => r.data?.invoice_no || r.file).join(", ");
        toast.error(
          dupe === 1
            ? `This invoice (${dupeNames}) has already been extracted.`
            : `${dupe} invoices were already extracted before: ${dupeNames}`,
          { duration: 6000 }
        );
      }
      if (bad)  toast.error(`${bad} file${bad > 1 ? "s" : ""} failed.`);

      if (hadRateLimit) {
        setRateLimitInfo({ retryAfter: hadRateLimit.retry_after || null });
        toast.error("API rate limit hit — see banner below for retry time.");
      }

      onUploaded(allResults);
      setFiles([]);
      setProgress({});
    } finally {
      setLoading(false);
      setFileProgress({ done: 0, total: 0 });
    }
  };

  return (
    <div className="upload-zone-wrap">
      {loading && fileProgress.total > 0 && (
        <div className="batch-loader-backdrop">
          <div className="batch-loader-card">
            <div className="spinner" />
            <p className="batch-loader-title">Processing your invoices…</p>
            <p className="batch-loader-sub">
              {fileProgress.done} of {fileProgress.total} files processed
            </p>
            <div className="batch-loader-track">
              <div
                className="batch-loader-fill"
                style={{ width: `${(fileProgress.done / fileProgress.total) * 100}%` }}
              />
            </div>
          </div>
          {vendorMismatch && (
        <ConfirmModal
          title="Vendor Mismatch"
          message={`Extracted vendor "${vendorMismatch.payload.extracted_vendor_name}" does not match the reported vendor "${vendorMismatch.payload.reported_vendor_name}". Do you want to proceed anyway?`}
          onConfirm={() => { const { resolve } = vendorMismatch; setVendorMismatch(null); resolve(true); }}
          onCancel={()  => { const { resolve } = vendorMismatch; setVendorMismatch(null); resolve(false); }}
        />
      )}
        </div>
      )}

      {rateLimitInfo && (
        <RateLimitBanner
          retryAfter={rateLimitInfo.retryAfter}
          onDismiss={() => setRateLimitInfo(null)}
        />
      )}
      <div
        {...getRootProps()}
        className={`dropzone ${isDragActive ? "active" : ""}`}
      >
        <input {...getInputProps()} />
        <div className="dz-icon">
          <svg viewBox="0 0 64 64" fill="none" width="56" height="56">
            <circle cx="32" cy="32" r="30" stroke="currentColor" strokeWidth="2" opacity=".15"/>
            <path d="M32 20v16M24 28l8-8 8 8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M20 42h24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity=".5"/>
          </svg>
        </div>
        <p className="dz-title">
          {isDragActive ? "Drop PDFs here…" : "Drag & drop PDF invoices"}
        </p>
        <p className="dz-sub">or click to browse · multiple files supported</p>
      </div>

      {files.length > 0 && (
        <div className="file-list">
          <div className="file-list-header">
            <span>{files.length} file{files.length > 1 ? "s" : ""} queued</span>
            <button className="btn-ghost" onClick={clearAll}>Clear all</button>
          </div>
          {files.map(f => (
            <div key={f.name} className="file-row">
              <span className="file-icon">📄</span>
              <span className="file-name">{f.name}</span>
              <span className="file-size">{(f.size / 1024).toFixed(0)} KB</span>
              {progress[f.name] === "done"      && <span className="badge badge-ok">✓</span>}
              {progress[f.name] === "duplicate" && <span className="badge badge-dupe" title="Already extracted">⚠ Duplicate</span>}
              {progress[f.name] === "error"     && <span className="badge badge-err">✗</span>}
              {progress[f.name] === "pending"   && <span className="badge badge-wait">…</span>}
              {!progress[f.name] && (
                <button className="btn-remove" onClick={() => removeFile(f.name)}>×</button>
              )}
            </div>
          ))}
          <button
            className="btn-primary btn-upload"
            onClick={upload}
            disabled={loading}
          >
            {loading
              ? `Processing ${fileProgress.done}/${fileProgress.total} files…`
              : `Extract ${files.length} Invoice${files.length > 1 ? "s" : ""}`}
          </button>
        </div>
      )}
    </div>
  );
}